<template>
  <b-row>
    <b-col class="approval-top-line" cols="12">
      <b-btn
          :disabled="!selected.length"
          :title="title"
          variant="success"
          @click="billInvoices">
        {{$t('buttons.common.bill_and_post')}}
      </b-btn>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ApprovalTopLine',
  computed: {
    ...mapGetters('invoicesApproval', ['approvalTabGridOptions']),
    ...mapState('invoicesApproval', ['selected']),
    disabled () {
      return !this.selected.length
    },
    title () {
      return this.disabled
        ? 'Select invoices for billing'
        : 'Bill invoices'
    }
  },
  methods: {
    async billInvoices () {
      await this.$store.dispatch('invoicesApproval/billInvoices')
      await this.$store.dispatch('invoicesApproval/loadApprovalTab')
      this.approvalTabGridOptions.api.deselectAll()
    }
  }
}
</script>
<style scoped lang="sass">
.approval-top-line
  margin-bottom: 5px
  display: flex
  justify-content: flex-end
</style>


// WEBPACK FOOTER //
// src/components/common/invoices-approval/ApprovalTopLine.vue